import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import _14x151 from "./14x151.png";
import _14x152 from "./14x152.png";
import _14x153 from "./14x153.png";

const width = "70%";
const height = "auto";
const viewBox = "0 0 466 233";

const getDimensions = (size, sizes) => {
  if (
    size &&
    typeof size.width === "number" &&
    typeof size.height === "number"
  ) {
    return size;
  }
  return size && sizes[size] ? sizes[size] : { width, height };
};

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) {
    return "";
  }
  const dimensions = getDimensions(size, sizes);
  const fillRule =
    fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : "";
  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
    ${fillRule};
  `;
};

const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
  getCss(size, sizes, fillColor, fillColorRule, noStyles);

const Image = styled.svg`
  ${propsToCss};
`;

const children = (
  <Fragment>
    <defs key="key-0">
      <linearGradient
        id="s-abc7dd7d38-a"
        x1="-2594.49"
        x2="-2594.24"
        y1="342.78"
        y2="342.78"
        gradientTransform="matrix(-1 0 0 1 -2383.04 -270.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#595959" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#5c5c5c" />
      </linearGradient>
      <linearGradient
        id="s-abc7dd7d38-d"
        x1="-2593.3"
        x2="-2593.05"
        y1="342.73"
        y2="342.73"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-e"
        x1="-2592.19"
        x2="-2591.94"
        y1="342.67"
        y2="342.67"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-f"
        x1="-2591.08"
        x2="-2590.83"
        y1="342.59"
        y2="342.59"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-g"
        x1="-2589.89"
        x2="-2589.64"
        y1="342.52"
        y2="342.52"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-h"
        x1="-2588.78"
        x2="-2588.53"
        y1="342.45"
        y2="342.45"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-i"
        x1="-2587.66"
        x2="-2587.41"
        y1="342.39"
        y2="342.39"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-j"
        x1="-2586.47"
        x2="-2586.22"
        y1="342.31"
        y2="342.31"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-k"
        x1="-2585.36"
        x2="-2585.11"
        y1="342.25"
        y2="342.25"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-l"
        x1="-2584.25"
        x2="-2584"
        y1="342.19"
        y2="342.19"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-m"
        x1="-2583.06"
        x2="-2582.81"
        y1="342.15"
        y2="342.15"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-n"
        x1="-2581.95"
        x2="-2581.7"
        y1="342.03"
        y2="342.03"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-o"
        x1="-2580.87"
        x2="-2580.62"
        y1="341.96"
        y2="341.96"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-p"
        x1="-2579.68"
        x2="-2579.43"
        y1="341.93"
        y2="341.93"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-q"
        x1="-2578.57"
        x2="-2578.32"
        y1="341.86"
        y2="341.86"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-r"
        x1="-2599.32"
        x2="-2583.04"
        y1="332.51"
        y2="332.51"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-s"
        x1="-2599.31"
        x2="-2583.03"
        y1="331.05"
        y2="331.05"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-t"
        x1="-2599.3"
        x2="-2583.03"
        y1="329.67"
        y2="329.67"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-u"
        x1="-2599.3"
        x2="-2583.02"
        y1="328.22"
        y2="328.22"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-v"
        x1="-2599.29"
        x2="-2583.02"
        y1="326.84"
        y2="326.84"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-w"
        x1="-2599.43"
        x2="-2583.15"
        y1="362.2"
        y2="362.2"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-x"
        x1="-2599.43"
        x2="-2583.15"
        y1="363.4"
        y2="363.4"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-y"
        x1="-2599.42"
        x2="-2583.14"
        y1="360.82"
        y2="360.82"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-z"
        x1="-2599.42"
        x2="-2583.14"
        y1="359.36"
        y2="359.36"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-A"
        x1="-2599.41"
        x2="-2583.13"
        y1="357.98"
        y2="357.98"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-B"
        x1="-2599.4"
        x2="-2583.13"
        y1="356.53"
        y2="356.53"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-C"
        x1="-2599.4"
        x2="-2583.12"
        y1="355.15"
        y2="355.15"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-D"
        x1="-2599.39"
        x2="-2583.12"
        y1="353.69"
        y2="353.69"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-E"
        x1="-2599.39"
        x2="-2583.11"
        y1="352.31"
        y2="352.31"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-F"
        x1="-2599.38"
        x2="-2583.11"
        y1="350.86"
        y2="350.86"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-G"
        x1="-2599.38"
        x2="-2583.1"
        y1="349.44"
        y2="349.44"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-H"
        x1="-2599.37"
        x2="-2583.1"
        y1="347.98"
        y2="347.98"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-I"
        x1="-2599.37"
        x2="-2583.09"
        y1="346.6"
        y2="346.6"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-J"
        x1="-2599.36"
        x2="-2583.09"
        y1="345.15"
        y2="345.15"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-K"
        x1="-2599.36"
        x2="-2583.08"
        y1="343.77"
        y2="343.77"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-L"
        x1="-2599.35"
        x2="-2583.07"
        y1="342.31"
        y2="342.31"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-M"
        x1="-2599.35"
        x2="-2583.07"
        y1="340.93"
        y2="340.93"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-N"
        x1="-2599.34"
        x2="-2583.06"
        y1="339.48"
        y2="339.48"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-O"
        x1="-2599.34"
        x2="-2583.06"
        y1="338.1"
        y2="338.1"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-P"
        x1="-2599.33"
        x2="-2583.05"
        y1="336.64"
        y2="336.64"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-Q"
        x1="-2599.33"
        x2="-2583.05"
        y1="335.26"
        y2="335.26"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-R"
        x1="-2599.32"
        x2="-2583.04"
        y1="333.81"
        y2="333.81"
        gradientTransform="matrix(-.99 0 0 1 -2370.02 -263.2)"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <linearGradient
        id="s-abc7dd7d38-S"
        x1="193.8"
        x2="212.91"
        y1="71.04"
        y2="71.04"
        xlinkHref="#s-abc7dd7d38-a"
      />
      <radialGradient
        id="s-abc7dd7d38-T"
        cx="197.22"
        cy="67.78"
        r="1.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#999" />
        <stop offset="1" stopColor="#4d4d4d" />
      </radialGradient>
      <linearGradient
        id="s-abc7dd7d38-U"
        x1="440.1"
        x2="440.12"
        y1="338.02"
        y2="337.5"
        gradientTransform="matrix(1.11 .01 .01 1 -291.37 -272.24)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#4d4d4d" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#4d4d4d" />
      </linearGradient>
      <linearGradient
        id="s-abc7dd7d38-V"
        x1="1967.95"
        x2="1968.18"
        y1="753.86"
        y2="753.43"
        gradientTransform="rotate(-27.38 391.605 3461.088)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d45a24" />
        <stop offset=".84" stopColor="#a2272d" />
      </linearGradient>
      <linearGradient
        id="s-abc7dd7d38-W"
        x1="722.74"
        x2="723.14"
        y1="1005.97"
        y2="1006.1"
        gradientTransform="matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f15a24" />
        <stop offset=".83" stopColor="#a6272d" />
      </linearGradient>
      <linearGradient
        id="s-abc7dd7d38-b"
        x1="544.56"
        x2="544.72"
        y1="331.24"
        y2="331.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#be1e2d" />
        <stop offset="1" stopColor="#ee4036" />
      </linearGradient>
      <linearGradient
        id="s-abc7dd7d38-X"
        x1="543"
        x2="552.06"
        y1="332.32"
        y2="332.32"
        xlinkHref="#s-abc7dd7d38-b"
      />
      <linearGradient
        id="s-abc7dd7d38-c"
        x1="384.36"
        x2="384.36"
        y1="397.79"
        y2="412.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#c1272d" />
        <stop offset=".53" stopColor="#c6594b" />
        <stop offset="1" stopColor="#c1272d" />
      </linearGradient>
      <linearGradient
        id="s-abc7dd7d38-Y"
        x1="368.17"
        x2="401.04"
        y1="404.58"
        y2="404.58"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-Z"
        x1="389.9"
        x2="400.86"
        y1="387.58"
        y2="387.58"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-aa"
        x1="369.06"
        x2="380.02"
        y1="399.91"
        y2="399.91"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-ab"
        x1="379.15"
        x2="401.47"
        y1="394.35"
        y2="394.35"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-ac"
        x1="380.08"
        x2="401.48"
        y1="394.74"
        y2="394.74"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-ad"
        x1="-1101.73"
        x2="-1101.73"
        y1="416.42"
        y2="436.87"
        gradientTransform="matrix(-1 0 0 1 -677.76 -270.72)"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-ae"
        x1="-1109.85"
        x2="-1093.16"
        y1="425.91"
        y2="425.91"
        gradientTransform="matrix(-1 0 0 1 -677.76 -270.72)"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-af"
        x1="673.89"
        x2="684.34"
        y1="406.87"
        y2="406.87"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-ag"
        x1="680.42"
        x2="690.58"
        y1="425.47"
        y2="425.47"
        xlinkHref="#s-abc7dd7d38-c"
      />
      <linearGradient
        id="s-abc7dd7d38-ah"
        x1="673.74"
        x2="680.74"
        y1="416.62"
        y2="416.62"
        xlinkHref="#s-abc7dd7d38-c"
      />
    </defs>
    <g id="surface">
      <g id="mainSurface">
        <path
          d="M464.88 232.42L1.61 197.35 183.63 88.72l236.06 14.31 45.19 129.39z"
          style={{
            fill: "#4d4d4d",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M450.31 223.69L25.34 191.43l161.7-96.52 224.94 13.77 38.33 115.01z"
          style={{
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M222.99 206.34l70.7-104.9"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <path
        id="surfaceBasket"
        className="basketball"
        d="M312.63 130.17l-74.67-3.77 21.2-26.85 68.17 3.84-14.7 26.78z"
      />
    </g>
    <g id="lines">
      <g id="basketballLines" className="basketball">
        <path
          d="M450.27 366.61c-54.66 51.75 207.5 64.24 216.48 12.18"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M312.63 130.17l-74.67-3.77 21.2-26.85 68.17 3.84-14.7 26.78z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M571.45 400.89c-5.09 6.35-18.87 10.85-37.1 10.56-20.77-.34-40.84-5.23-37.6-14.58"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-258.81 -270.72)"
        />
      </g>
    </g>
    <image
      id="high"
      width="1826"
      height="927"
      transform="translate(24.15) scale(.24)"
      xlinkHref={_14x151}
    />
    <image
      id="medium"
      width="1823"
      height="848"
      transform="matrix(.24 0 0 .24 24.39 17.04)"
      xlinkHref={_14x152}
    />
    <image
      id="small"
      width="1843"
      height="805"
      transform="matrix(.24 0 0 .24 19.83 29.52)"
      xlinkHref={_14x153}
    />
    <g id="wicket">
      <path
        d="M212.41 90.84L194.3 89.8V51.37l18.11 1.05v38.42z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M212.18 62.54l-.85-.07V59.1l.85.07v3.37zM212.18 83.83l-.85-.07V80.4l.85.07v3.36z"
        style={{
          fill: "#999",
        }}
      />
      <path
        d="M211.33 53.9v36.33"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-a)",
        }}
      />
      <path
        d="M210.14 53.83v36.35"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-d)",
        }}
      />
      <path
        d="M209.03 53.78v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-e)",
        }}
      />
      <path
        d="M207.92 53.66v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-f)",
        }}
      />
      <path
        d="M206.73 53.59V90"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-g)",
        }}
      />
      <path
        d="M205.62 53.53v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-h)",
        }}
      />
      <path
        d="M204.5 53.47v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-i)",
        }}
      />
      <path
        d="M203.31 53.38v36.43"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-j)",
        }}
      />
      <path
        d="M202.2 53.32v36.42"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-k)",
        }}
      />
      <path
        d="M201.09 53.25v36.44"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-l)",
        }}
      />
      <path
        d="M199.9 53.25V89.6"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-m)",
        }}
      />
      <path
        d="M198.79 53.11v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-n)",
        }}
      />
      <path
        d="M197.71 53.07v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-o)",
        }}
      />
      <path
        d="M196.52 53.01v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-p)",
        }}
      />
      <path
        d="M195.41 52.94v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-q)",
        }}
      />
      <path
        d="M211.33 59.5l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-r)",
        }}
      />
      <path
        d="M211.33 58.05l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-s)",
        }}
      />
      <path
        d="M211.33 56.67l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-t)",
        }}
      />
      <path
        d="M211.33 55.22l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-u)",
        }}
      />
      <path
        d="M211.33 53.84l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-v)",
        }}
      />
      <path
        d="M211.33 89.13l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-w)",
        }}
      />
      <path
        d="M211.33 90.33l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-x)",
        }}
      />
      <path
        d="M211.33 87.75l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-y)",
        }}
      />
      <path
        d="M211.33 86.3l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-z)",
        }}
      />
      <path
        d="M211.33 84.92l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-A)",
        }}
      />
      <path
        d="M211.33 83.47l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-B)",
        }}
      />
      <path
        d="M211.33 82.09l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-C)",
        }}
      />
      <path
        d="M211.33 80.64l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-D)",
        }}
      />
      <path
        d="M211.33 79.26l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-E)",
        }}
      />
      <path
        d="M211.33 77.81l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-F)",
        }}
      />
      <path
        d="M211.33 76.39l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-G)",
        }}
      />
      <path
        d="M211.33 74.94l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-H)",
        }}
      />
      <path
        d="M211.33 73.57l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-I)",
        }}
      />
      <path
        d="M211.33 72.11l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-J)",
        }}
      />
      <path
        d="M211.33 70.74l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-K)",
        }}
      />
      <path
        d="M211.33 69.28l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-L)",
        }}
      />
      <path
        d="M211.33 67.91l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-M)",
        }}
      />
      <path
        d="M211.33 66.46l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-N)",
        }}
      />
      <path
        d="M211.33 65.08l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-O)",
        }}
      />
      <path
        d="M211.33 63.63l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-P)",
        }}
      />
      <path
        d="M211.33 62.25l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-Q)",
        }}
      />
      <path
        d="M211.33 60.8l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-abc7dd7d38-R)",
        }}
      />
      <path
        d="M194.3 89.61V51.42l18.11 1.05v38.19"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-abc7dd7d38-S)",
        }}
      />
      <circle
        cx="197.22"
        cy="67.78"
        r="1.36"
        style={{
          fill: "url(#s-abc7dd7d38-T)",
        }}
      />
      <path
        d="M197.22 67.78l3.45.17"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          stroke: "url(#s-abc7dd7d38-U)",
        }}
      />
    </g>
    <g id="basketballAcross" className="basketball">
      <path
        d="M295.04 102.06l-2.1-.12V57.09l2.1-.02v44.99z"
        style={{
          fill: "#666",
        }}
      />
      <path
        d="M295.04 102.06l1.04-.58V56.74l-1.04.33v44.99z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M296.08 56.74l-1.04.33-2.67.01 1.85-.42 1.86.08z"
        style={{
          fill: "#858589",
        }}
      />
      <path
        d="M294.77 73.4l-1.83-.14-3.22-14.24 1.83.15 3.22 14.23z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M294.77 68.77v4.63l-3.21-14.23h-2.03l.98-1.01h1.86l2.4 10.61z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M562.55 321.46c-1.4-4.76-6.45-8.29-12.49-8.29s-10.46 2.14-11.86 6.91v6.08l5.86 6.18 12.15.71 6.29-5.49v-.07z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M556.27 333.13l-12.22-.71-5.91-6.25v-6.1c1.34-4.56 5.47-7 11.94-7 6 0 11.12 3.44 12.57 8.35v6.17zm-12.14-.88l12.08.7 6.25-5.45v-6c-1.44-4.84-6.54-8.22-12.41-8.22-6.38 0-10.45 2.37-11.77 6.84v6z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M555.68 332.51l-11.39-.66-5.54-5.85V320.24c1.26-4.28 5.12-6.54 11.16-6.54 5.56 0 10.39 3.21 11.75 7.82V327.33l-.08.12zm-11.16-1.16l11 .64 5.64-4.86v-5.51c-1.31-4.36-5.93-7.41-11.25-7.41-4 0-9.15 1.07-10.66 6.14v5.48z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M292.04 61.49l-2.48-.15v-2.33l2.48.13v2.35z"
        style={{
          fill: "#c1272d",
        }}
      />
      <path
        d="M554.37 330.3l-9.16-.5v-7.59l9.16.5zm-8.55-1.09l7.93.44v-6.35l-7.93-.44z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M549.89 330.66a2.9 2.9 0 0 0-1.16-.25 4.13 4.13 0 0 0-1.36.08l1-.76 2.48.13z"
        style={{
          fill: "#ea371f",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M549.27 331.77l-5.78.24a.13.13 0 0 1-.16-.09.12.12 0 0 1 .08-.15l5.78-.24a.13.13 0 0 1 .16.09.12.12 0 0 1-.08.15z"
        style={{
          fill: "url(#s-abc7dd7d38-V)",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M551.93 332.27a.22.22 0 0 1 0 .14c0 .07-.11.07-.17 0l-2.06-.63a.23.23 0 0 1 0-.24c0-.07.11-.07.16 0l2.07.63z"
        style={{
          fill: "url(#s-abc7dd7d38-W)",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M543.85 334.09a4.56 4.56 0 0 1-.14-.64l-.18-.12c.1.26.21.51.32.76zM544.55 334.28c.12.25.24.5.38.74a5.09 5.09 0 0 1-.41-1.17l-.14-.05c.05.2.11.32.17.48zM548.89 336.35c.18-.19.35-.39.52-.59a9.23 9.23 0 0 0-.19-1.05v-.1c-.19.29-.4.57-.61.85l.21.61c0 .07.03.17.07.28zM545.39 332.85l.24.92a5 5 0 0 0 .58.09c0-.66 0-1.33.1-2a3.2 3.2 0 0 1 .13-1.06 7.83 7.83 0 0 0-1.61.37 3.81 3.81 0 0 1 .56 1.68zM545 335a5.93 5.93 0 0 0 .82 1.16 2.81 2.81 0 0 0 .1-.31c0-.12.06-.24.08-.37-.13-.32-.24-.65-.34-1a2.92 2.92 0 0 1-.24-.37 7.73 7.73 0 0 1-.8-.21 4.21 4.21 0 0 0 .38 1.1zM549.28 334.44a6.22 6.22 0 0 1 .25 1.17v-.06c.07-.52.11-1 .13-1.54h-.17zM547.25 333.07c0-.29-.07-.58-.11-.87a4.43 4.43 0 0 0-.16-1c0-.08-.11-.25-.19-.27s-.23.18-.26.32a4.43 4.43 0 0 0-.09.9c0 .54 0 1.14-.07 1.76h1c-.06-.27-.09-.56-.12-.84zM547.49 334.28v.23l.09-.23h-.11zM549.75 335.31c.14-.21.27-.43.39-.65a5.29 5.29 0 0 0 .06-.8l-.35.11c-.02.44-.05.89-.1 1.34zM549.21 334.24l.09-.16h-.12a.59.59 0 0 1 .03.16zM547.37 334.75v-.47H547zM545.8 334.39c.11.13.22.27.32.41 0-.19 0-.39.06-.58l-.45-.06a1.55 1.55 0 0 1 .07.23zM546.27 335l.32.42c.09.13.19.25.29.38l.35-.71c0-.05 0-.09.07-.13a6.8 6.8 0 0 1-.38-.7h-.57c-.02.23-.04.49-.08.74zM547.52 334.82a1.28 1.28 0 0 0 0 .19c.17.29.33.59.49.88.14-.17.27-.35.41-.53q-.2-.54-.36-1.11h-.32c-.06.2-.14.39-.22.57zM550.33 334.15c0-.13.09-.25.13-.38h-.12c0 .15 0 .23-.01.38zM548.51 335.25c.22-.28.42-.57.62-.86a1.29 1.29 0 0 1-.06-.25c-.3.05-.6.08-.92.11.13.33.25.66.36 1zM549.15 333.76l.43-.09c.11-.19.21-.38.31-.57a13.31 13.31 0 0 1 .84-1.84 6.31 6.31 0 0 0-1.69-.45v.24c.12.95.02 1.81.11 2.71zM551.69 332.23c0-.3-.27-.6-.72-.85a7.81 7.81 0 0 1-.23 1.88c.61-.26.96-.68.95-1.03zM544.12 334.61c.18.33.38.65.59 1v.11c.22.32.46.64.7.95l.09.12.15-.33a8.73 8.73 0 0 1-1-1.38 8.17 8.17 0 0 1-.55-1.3l-.31-.16a10.52 10.52 0 0 0 .33.99zM543.81 333.09l.25.17c-.12-.39-.23-.78-.32-1.18a5.65 5.65 0 0 0 .07 1.01z"
        style={{
          fill: "none",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M547.47 333.92h.27c.08-.21.14-.42.2-.64.15-.56.24-1.12.4-1.67a3.39 3.39 0 0 1 .3-.83 10.58 10.58 0 0 0-1.15 0h-.57a3.78 3.78 0 0 1 .4 1.61c.06.49.11 1.01.15 1.53zM549 331.7a3.58 3.58 0 0 0 0-.73c-.09-.34-.15-.05-.22.1s-.11.28-.16.42c-.16.49-.25 1-.37 1.51a6.69 6.69 0 0 1-.27.9 9.38 9.38 0 0 0 1.12-.12 17.93 17.93 0 0 1-.1-2.08zM544.45 333.44a7.61 7.61 0 0 1 0-2.13 3.24 3.24 0 0 0-.7.42c.13.54.28 1.08.45 1.61zM550 335.94c.15-.3.29-.6.41-.91a10.14 10.14 0 0 0 .33-1.37h-.09a4.7 4.7 0 0 1-.35.93 8.29 8.29 0 0 1-.3 1.35z"
        style={{
          fill: "none",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M286.76 63.41z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M550.63 334.71c0 .15-.09.3-.14.45a8.94 8.94 0 0 0 .9-1.87 3.16 3.16 0 0 1-.41.24 10 10 0 0 1-.35 1.18zM550.85 331.32a6.15 6.15 0 0 0-.44 1 10.45 10.45 0 0 1-.56 1.17l-.06.1a5.69 5.69 0 0 0 .8-.28 7.65 7.65 0 0 0 .26-1.99zM547.06 337l.29-.34-.46-.63c-.07.13-.14.27-.22.4a5.72 5.72 0 0 0 .39.57zM549.71 335.57c0 .25-.07.51-.11.76l.19-.19c.11-.37.21-.75.29-1.13-.08.19-.24.38-.37.56zM548.94 336.49c0 .12.09.25.14.38l.34-.36a.5.5 0 0 0 0-.12v-.45c-.15.19-.31.37-.48.55zM544.49 332.44a7.17 7.17 0 0 0 .07 1 4.91 4.91 0 0 0 .91.27c-.14-.54-.26-1.07-.39-1.6 0-.13-.16-.81-.36-.94l-.16.07a4.74 4.74 0 0 0 0 .69c-.06.2-.07.36-.07.51zM547.53 335.36v1.12l.39-.48c-.12-.21-.25-.43-.39-.64zM546.81 335.94l-.34-.44c-.07-.1-.15-.19-.23-.29v.3a7.12 7.12 0 0 0 .41.83zM543.64 331.86a.76.76 0 0 0-.27.56.78.78 0 0 0 .27.53 7.93 7.93 0 0 1 0-1.09zM547.38 335.11c-.13.27-.27.53-.41.8l.42.57q.01-.68-.01-1.37zM548.49 336.76l.31-.31c0-.13-.08-.25-.13-.38l-.18-.53-.39.5c0 .07.07.13.1.2zM546.09 335l-.15-.19.12.36zM546.51 336.49l-.12-.21c-.09-.17-.17-.35-.25-.53 0 .18-.1.36-.16.54l.4.42a2.53 2.53 0 0 0 .13-.22zM545.79 336.26a7.28 7.28 0 0 1-.44-.57 5.9 5.9 0 0 0 .43.59z"
        style={{
          fill: "none",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M544.45 333.44h.11a7.17 7.17 0 0 1-.07-1v-.47a4.74 4.74 0 0 1 0-.69h-.08a7.61 7.61 0 0 0 .04 2.16zM546.21 333.86h.16c0-.62 0-1.22.07-1.76a4.43 4.43 0 0 1 .09-.9c0-.14.09-.37.26-.32s.16.19.19.27a4.43 4.43 0 0 1 .16 1c0 .29.08.58.11.87s.06.57.08.85h.14c0-.52-.09-1-.15-1.55a3.78 3.78 0 0 0-.4-1.61l-.48.05a3.2 3.2 0 0 0-.13 1.06c-.05.71-.06 1.38-.1 2.04zM543.81 333.09a5.65 5.65 0 0 1-.07-1c.09.4.2.79.32 1.18l.17.08c-.17-.53-.32-1.07-.45-1.61a.86.86 0 0 0-.14.13 7.93 7.93 0 0 0 0 1.09zM544.55 330.9a.18.18 0 0 0-.11 0h.12zM545.08 332.15c.13.53.25 1.06.39 1.6h.16l-.24-.92a3.81 3.81 0 0 0-.56-1.67h-.11c.2.18.33.84.36.99z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M550.49 335.16c0-.15.1-.3.14-.45a10 10 0 0 0 .34-1.15l-.26.13a10.14 10.14 0 0 1-.33 1.37c-.12.31-.26.61-.41.91a8.29 8.29 0 0 0 .3-1.31 4.7 4.7 0 0 0 .35-.93l-.17.07c0 .13-.08.25-.13.38v-.34l-.14.05a5.29 5.29 0 0 1-.06.8c-.12.22-.25.44-.39.65 0-.45.08-.9.1-1.34h-.15c0 .51-.06 1-.13 1.54v.06a6.22 6.22 0 0 0-.25-1.17l.25-.4h-.22l-.09.16a.59.59 0 0 0 0-.13h-.12a1.29 1.29 0 0 0 .06.25c-.2.29-.4.58-.62.86-.11-.34-.23-.67-.36-1h-.08q.16.57.36 1.11c-.14.18-.27.36-.41.53-.16-.29-.32-.59-.49-.88a1.28 1.28 0 0 1 0-.19c.08-.18.16-.37.23-.55h-.15l-.09.23v-.23h-.14v.47l-.34-.48h-.11a6.8 6.8 0 0 0 .38.7s0 .08-.07.13l-.35.71c-.1-.13-.2-.25-.29-.38l-.32-.42c0-.26.06-.52.08-.78h-.17c0 .19 0 .39-.06.58-.1-.14-.21-.28-.32-.41a1.55 1.55 0 0 0-.07-.23H545.49a2.92 2.92 0 0 0 .24.37c.1.33.21.66.34 1 0 .13 0 .25-.08.37a2.81 2.81 0 0 1-.1.31A5.93 5.93 0 0 1 545 335a4.21 4.21 0 0 1-.38-1.08h-.11a5.09 5.09 0 0 0 .41 1.17c-.14-.24-.26-.49-.38-.74s-.12-.32-.17-.48l-.19-.08a8.17 8.17 0 0 0 .55 1.3 8.73 8.73 0 0 0 1 1.38l-.15.33-.09-.12c-.24-.31-.48-.63-.7-.95v-.11c-.21-.32-.41-.64-.59-1a10.52 10.52 0 0 1-.24-1.05l-.17-.11a4.56 4.56 0 0 0 .14.64c-.11-.25-.22-.5-.32-.76a.86.86 0 0 1-.14-.13 9.38 9.38 0 0 0 1.38 2.71c.11.36.22.72.35 1.07a3.88 3.88 0 0 0 0 .59 11.12 11.12 0 0 1-.09 1.53v.35c-.08.4-.29 1.56.26 1.16a.71.71 0 0 0 .31.24.46.46 0 0 0 .48-.16c.13.23.31.45.54.43a.5.5 0 0 0 .35-.25l.08-.12a.6.6 0 0 0 .86.15 1.08 1.08 0 0 0 .27-.29.73.73 0 0 0 .17.18c.33.23.48-.14.54-.41a.29.29 0 0 0 0-.09l.17.31a.07.07 0 0 0 .13 0 6.43 6.43 0 0 0 .09-1.7 4.47 4.47 0 0 1 .08-.82v-.06a8 8 0 0 1 .2-.81.75.75 0 0 1 .07-.12c.19-.36.36-.73.52-1.1v-.05-.11a10.56 10.56 0 0 0 1.31-2.65l-.2.17a8.94 8.94 0 0 1-.85 1.8zm-1.31-.58v.1a9.23 9.23 0 0 1 .19 1.05c-.17.2-.34.4-.52.59 0-.11-.07-.21-.11-.31l-.21-.61c.25-.25.47-.53.65-.82zm-3.87 2.89c.06.16.13.32.2.48l-.19.22c0-.21-.06-.41-.09-.62zm-.09 0v-.27c0-.09 0 .12.07.19zm.36.63c.06.14.13.29.2.43l-.3.37c-.05-.19-.1-.39-.14-.59zm1.54-.41l-.19-.18zm-.09-.3l.06-.08c.12.15.25.29.38.44l-.07.06c-.12-.15-.24-.3-.4-.43zm.2.58l-.4.39-.31-.38.32-.37zm-.34-.73l-.41-.42.11-.19a6.28 6.28 0 0 0 .38.52zm-.1.11a.6.6 0 0 1-.08-.08l-.31-.3c.14.1.27.23.39.37zm-.1.12l-.3.34-.29-.36.22-.34zm-.38.44l-.43.51-.21-.43a3.65 3.65 0 0 0 .35-.43zm-.43.8c.07.15.15.29.23.43l-.12.14c-.09.11-.18.23-.26.35-.08-.18-.14-.36-.2-.54zm.15 0l-.06-.11c.16-.18.32-.35.47-.53l.3.37c-.19.19-.37.38-.54.58zm.8-.15l.37.48-.23.27c-.11.15-.23.29-.34.43-.12-.19-.24-.39-.35-.59.17-.15.36-.4.55-.59zm.08-.09l.26-.26.16-.16.38.38-.43.51c-.12-.16-.28-.32-.37-.47zm1.47-.52l.35-.39c.06.14.13.28.2.42l-.29.39c-.08-.14-.17-.28-.26-.37zm.13.59l-.09.12-.33-.39.17-.18zm-.24-.77c-.08-.13-.17-.25-.25-.37.14-.14.28-.28.43-.41l.18.37zm-.12.13c-.06.08-.13.15-.19.22l-.31-.35.27-.25zm-.26.31l-.1.11-.06-.06c-.08-.12-.16-.24-.25-.35l.08-.07zm-.06.36c.11.13.21.26.31.4l-.1.12c-.12.14-.25.28-.37.43l-.06-.1c-.08-.12-.16-.23-.25-.34zm.23.05l-.14-.16.1-.1c.11.13.22.26.32.4l-.09.11c-.06-.09-.13-.17-.19-.25zm.36.24l.25.36a1.11 1.11 0 0 0-.07.16c-.08-.13-.18-.27-.27-.4zm.08-.09l.08-.11c.06.11.12.22.17.33v.1zm.21-.27l.28-.38v.06l-.18.56a.616.616 0 0 0-.1-.24zm.12-1.06l.22-.24c0 .13.09.26.13.39 0 .08-.1.17-.16.25-.02-.13-.12-.27-.19-.4zm-.1-.2l-.18-.35.29-.3c0 .13.09.26.13.39zm-.24-1.7l.18.53c.05.13.09.25.13.38l-.31.31-.29-.52c0-.07-.07-.13-.1-.2zm-.44.69q.18.31.33.63c-.14.15-.29.29-.44.43l-.3-.45-.09-.11.46-.57a.25.25 0 0 1 .04.07zm-.52-.87c.14.21.27.43.39.64l-.39.48c.01-.37.01-.75 0-1.12zm0 1.56c.11.15.21.31.31.47l-.16.15-.12.12-.37-.47c.1-.11.19-.23.28-.35zm-.55-1c.14-.27.28-.53.41-.8v1.38l-.42-.57zm-.08.15l.46.63-.29.34a5.72 5.72 0 0 1-.39-.57c.07-.14.14-.28.21-.41zm-.65-.85c.08.1.16.19.23.29l.34.44-.21.4a7.12 7.12 0 0 1-.41-.83c.01-.11.03-.21.04-.31zm-.3-.38l.15.19v.17zm.2.92c.08.18.16.36.25.53l.12.21a2.53 2.53 0 0 1-.13.22l-.4-.42c.01-.19.1-.37.15-.55zm-.21.67c.12.14.25.28.38.41a5.14 5.14 0 0 1-.38-.42zm-.58-.73c.13.19.28.38.44.57a5.9 5.9 0 0 1-.45-.58zm.5.91l.36.39-.21.33-.31-.4a3.18 3.18 0 0 0 .15-.33zm-.23.44l.3.38c-.1.15-.2.28-.31.42l-.21-.48a3.62 3.62 0 0 0 .21-.37zm-.67-.88c.18.25.37.5.56.74 0 .11-.11.22-.16.32-.15-.36-.28-.71-.36-1.07zm.27 2.28c0 .19.09.39.15.59s-.15.2-.23.3c0-.34.05-.61.07-.9zm-.19 1.47a1.68 1.68 0 0 0 .09.32c-.13-.11-.13-.14-.13-.33zm.28.39a1.59 1.59 0 0 1-.15-.5v-.31l.29-.3a5.37 5.37 0 0 0 .21.56c-.09.13-.17.26-.25.39a.73.73 0 0 1-.11.15zm.1.13c.05-.1.09-.2.14-.29l.16-.24c.06.14.13.28.2.41l.1.2c-.15.12-.33.17-.61-.09zm.54-.32c-.06-.11-.11-.22-.16-.33.1-.14.2-.28.31-.41l.08-.1.34.61-.27.34-.14.18zm.64.6c-.29 0-.31 0-.4-.17l.07-.08c.11-.15.23-.29.34-.43a5.07 5.07 0 0 0 .36.54c-.09.13-.08.13-.38.13zm.44-.27c-.09-.14-.16-.29-.22-.39a1.4 1.4 0 0 0-.1-.16l.59-.71.09.12.22.32c-.14.18-.28.36-.41.55s-.13.17-.21.26zm1.09 0a.65.65 0 0 1-.81.3.7.7 0 0 1-.18-.17c.14-.21.26-.43.42-.64l.15-.2.27.4.16.3zm.07-.14a5.29 5.29 0 0 1-.41-.66l.46-.57c.1.14.2.3.3.45-.09.22-.18.43-.28.64zm.66-.14c0 .11 0 .22-.07.33-.23.11-.4.1-.49 0a5 5 0 0 0 .33-.8c.08.14.17.29.24.43a.17.17 0 0 1-.02.05zm0-.3a3.35 3.35 0 0 0-.21-.36l.06-.15c.06.1.11.21.17.32zm0-.43l-.13-.23v-.09l.11.21s.09.09.09.12zm0-.56l.06-.17v.26zm.24 1.47l-.17-.3v-.16c0 .12.09.25.12.38zm0-.27a2.86 2.86 0 0 0-.15-.41v-.13l.16.31a2 2 0 0 1 .08.24zm0-1.44v.9c0-.11-.09-.22-.14-.33 0-.26 0-.53.08-.79l.06.14zm0-.33l-.06-.12c0-.13.06-.25.1-.37v.08c.14.15.11.29.1.42zm0-1l-.09-.26.2-.21c.11.16.07.35.03.51zm.11.34v-.1zm.07-1.18l-.34.36c-.05-.13-.1-.26-.14-.38.17-.18.33-.36.48-.55v.45a.5.5 0 0 1 .14.16zm.23.07v.06a.93.93 0 0 1 0 .1v-.11l.09-.11zm0-.25c0-.25.08-.51.11-.76s.26-.37.37-.56c-.08.38-.18.76-.29 1.13z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M547.94 333.27c-.06.22-.12.43-.2.64h.15a6.69 6.69 0 0 0 .27-.9c.12-.51.21-1 .37-1.51.05-.14.1-.28.16-.42s.13-.44.22-.1a3.58 3.58 0 0 1 0 .73 17.93 17.93 0 0 0 .06 2.08h.14c-.09-.9 0-1.81-.08-2.71v-.24h-.4a3.39 3.39 0 0 0-.3.83c-.15.48-.24 1.04-.39 1.6zM549.58 333.67l.21-.06.06-.1a10.45 10.45 0 0 0 .56-1.17 6.15 6.15 0 0 1 .44-1 7.65 7.65 0 0 1-.26 2l.15-.07a7.81 7.81 0 0 0 .23-1.88l-.24-.12a13.31 13.31 0 0 0-.84 1.84c-.1.18-.2.37-.31.56zM551 331.28a.16.16 0 0 0 .11-.15.15.15 0 0 0-.16-.14.15.15 0 0 0-.15.15.08.08 0 0 0 0 .05l-.06.07.24.12zM546.81 330.65a.18.18 0 0 0-.35 0 .26.26 0 0 0 0 .08.2.2 0 0 0-.09.11l.52-.05a.38.38 0 0 0-.08-.14zM549.19 330.67a.17.17 0 0 0 0-.14.18.18 0 0 0-.21-.09c-.05 0-.11.06-.11.11a.27.27 0 0 0 0 .09l-.08.1.44.05a.5.5 0 0 0-.04-.12zM544.5 331.18a.59.59 0 0 0 0 .13h.08a.21.21 0 0 1 0-.07.13.13 0 0 1 .12 0h.11l-.13-.13a.14.14 0 0 0-.14-.15h-.12a.16.16 0 0 0 .08.22zM543.78 331.73v-.05a.13.13 0 0 0 0-.08.15.15 0 0 0-.15-.14.14.14 0 0 0-.14.14.13.13 0 0 0 .13.14v.12a.86.86 0 0 1 .16-.13z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M544.6 331.21a.21.21 0 0 0 0 .07l.16-.07a.13.13 0 0 0-.16 0z"
        style={{
          fill: "url(#s-abc7dd7d38-b)",
        }}
        transform="translate(-258.81 -270.72)"
      />
      <path
        d="M547.48 330.37a8.7 8.7 0 0 0-2.92.53.14.14 0 0 1 .14.15l.13.13a7.83 7.83 0 0 1 1.61-.37.44.44 0 0 1 .08-.1.19.19 0 0 1 0-.07.17.17 0 0 1 .16-.16.16.16 0 0 1 .16.15v.05l.1.08h.57a10.58 10.58 0 0 1 1.15 0 .36.36 0 0 1 .07-.1.19.19 0 0 1 0-.08.15.15 0 0 1 .11-.11.17.17 0 0 1 .19.08.15.15 0 0 1 0 .13.42.42 0 0 1 0 .12 6.31 6.31 0 0 1 1.69.45l.06-.07a.08.08 0 0 1 0-.05.15.15 0 0 1 .15-.15.15.15 0 0 1 .16.14.16.16 0 0 1-.11.15v.1c.45.25.71.55.72.85s-.34.72-1 1l-.15.07a5.69 5.69 0 0 1-.8.28l-.21.06-.43.09h-.14a9.38 9.38 0 0 1-1.12.12h-1.72a5 5 0 0 1-.58-.09h-.16a4.91 4.91 0 0 1-.91-.27h-.11l-.22-.1-.17-.08-.25-.17-.17-.14a.78.78 0 0 1-.27-.53.76.76 0 0 1 .27-.56v-.12a.13.13 0 0 1-.13-.14.14.14 0 0 1 .14-.14.15.15 0 0 1 .15.14.13.13 0 0 1 0 .08v.05a3 3 0 0 1 .7-.42.59.59 0 0 1 0-.13.16.16 0 0 1-.06-.24c-.9.38-1.45.91-1.44 1.49a1.09 1.09 0 0 0 .39.77.86.86 0 0 0 .14.13l.18.12.17.11.31.16.19.08.14.05h.11a7.73 7.73 0 0 0 .8.21H545.65l.45.06h1.97c.32 0 .62-.06.92-.11h.78l.35-.11.14-.05h.12l.17-.07h.09l.26-.13a3.16 3.16 0 0 0 .41-.24l.2-.17a1.24 1.24 0 0 0 .47-.9c.02-1.25-1.98-2.07-4.5-2.01z"
        style={{
          fill: "url(#s-abc7dd7d38-X)",
        }}
        transform="translate(-258.81 -270.72)"
      />
    </g>
    <g id="unihockey">
      <g id="unihockeyLeft">
        <path
          d="M141.85 151.4l-44.43-2.58L139 122.55l40.87 2.72-38.02 26.13z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M380.08 412.52l-11.91-.75v-1.09L389 398.23a3.16 3.16 0 0 1 2-.41l9.5 1.3v1.09l-9.22-.58a3.08 3.08 0 0 0-1.8.44l-16.69 10.12 7.26 1.24z"
          style={{
            fill: "url(#s-abc7dd7d38-c)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M379.94 411.42l-11.77-.74 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.11.64-.45.58a.41.41 0 0 1-.33.15l-9.14-.58a3.11 3.11 0 0 0-1.79.43l-18.61 11.1 10.4.66-.94.64a.34.34 0 0 1-.27.06z"
          style={{
            fill: "url(#s-abc7dd7d38-Y)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M399.86 379a26.14 26.14 0 0 1-5.79-.58v-.11a26.79 26.79 0 0 0 6.25.58v.11zM399.81 378.44a23.72 23.72 0 0 1-5.49-.56v-.11a24.73 24.73 0 0 0 6 .56v.1zM399.91 380.18a28.37 28.37 0 0 1-6.06-.6v-.11a28.19 28.19 0 0 0 6.47.6v.11zM399.89 379.6a27.29 27.29 0 0 1-5.89-.6v-.11a27.79 27.79 0 0 0 6.36.59v.11zM399.83 381.23a29.2 29.2 0 0 1-6.13-.58v-.11a30 30 0 0 0 6.62.58v.11zM399.92 380.65a29.18 29.18 0 0 1-6.16-.61v-.11a29.5 29.5 0 0 0 6.56.61v.11zM399.88 382.39a32.34 32.34 0 0 1-6.47-.6v-.11a31.9 31.9 0 0 0 6.9.6v.11zM399.84 381.81a30.34 30.34 0 0 1-6.32-.58v-.11a31.18 31.18 0 0 0 6.8.58v.11zM399.93 383.56a34 34 0 0 1-6.74-.63v-.11a34.85 34.85 0 0 0 7.13.63v.11zM400 383a33.12 33.12 0 0 1-6.67-.68v-.11a33.43 33.43 0 0 0 7 .67v.12zM399.77 384.72a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM399.94 384.14a35.08 35.08 0 0 1-6.86-.64v-.1a36.63 36.63 0 0 0 7.24.63v.11zM399.83 385.77a38.53 38.53 0 0 1-7.08-.6v-.11a38.35 38.35 0 0 0 7.57.6v.11zM399.8 385.19a37.17 37.17 0 0 1-6.94-.59v-.11a38 38 0 0 0 7.46.59v.11zM400 386.93a41.4 41.4 0 0 1-7.48-.73v-.11a40 40 0 0 0 7.77.73v.11zM399.85 386.35a39 39 0 0 1-7.21-.61v-.1a40.3 40.3 0 0 0 7.68.6v.11zM400 387.52a42.41 42.41 0 0 1-7.56-.71v-.11a40.72 40.72 0 0 0 7.89.7v.11zM399.91 388.68a44.29 44.29 0 0 1-7.72-.65v-.1a45.06 45.06 0 0 0 8.13.64v.11zM400 388.1a43.3 43.3 0 0 1-7.68-.71v-.11a43.42 43.42 0 0 0 8 .71v.1zM399.75 389.84a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM399.71 389.26a44.83 44.83 0 0 1-7.62-.58v-.11a45.17 45.17 0 0 0 8.23.58v.11zM399.79 391a49.89 49.89 0 0 1-8.07-.6v-.11a49.41 49.41 0 0 0 8.6.6v.11zM399.78 390.42a47.19 47.19 0 0 1-7.94-.6v-.1a49.14 49.14 0 0 0 8.49.59v.11zM399.81 392.06a51.15 51.15 0 0 1-8.29-.63v-.1a51.68 51.68 0 0 0 8.8.61v.11zM399.71 391.47a49.27 49.27 0 0 1-8.08-.58v-.11a49.85 49.85 0 0 0 8.7.58v.11zM399.71 393.22a54.21 54.21 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM400 392.64a52.81 52.81 0 0 1-8.53-.72v-.1a53 53 0 0 0 8.9.71v.1zM399.66 394.38a55.6 55.6 0 0 1-8.6-.59v-.11a56.17 56.17 0 0 0 9.27.59v.11zM399.64 393.8a55.08 55.08 0 0 1-8.45-.58v-.11a56.83 56.83 0 0 0 9.14.58v.11zM399.71 395.54a59 59 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM399.68 395a58.69 58.69 0 0 1-8.74-.59v-.11a59.88 59.88 0 0 0 9.38.59v.11zM399.75 396.6a63.37 63.37 0 0 1-9.12-.62v-.11a62.85 62.85 0 0 0 9.7.61v.11zM399.73 396a60.31 60.31 0 0 1-9-.61v-.1a62.39 62.39 0 0 0 9.58.6v.11zM399.65 397.76a66.15 66.15 0 0 1-9.26-.58v-.11a66.36 66.36 0 0 0 9.93.58v.11zM399.64 397.18a63.34 63.34 0 0 1-9.13-.58v-.11a66.67 66.67 0 0 0 9.82.58v.1z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M132.31 127.41l-.11-.02 3.93-20.77.11.02-3.93 20.77zM133.2 127.41l-.11-.02 3.75-20.84.11.02-3.75 20.84zM140.21 127.96h-.11l.16-21.25h.11l-.16 21.25z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M387.78 387.92h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 131.8 383.313)"
        />
        <path
          d="M138.71 127.8h-.11l.44-21.1h.11l-.44 21.1zM136.06 127.65l-.1-.01 2.28-21.08.1.01-2.28 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M386.73 387.84h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.3 127.001 385.761)"
        />
        <path
          d="M384.81 387.7h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 112.863 398.796)"
        />
        <path
          d="M384.04 387.67h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 107.574 402.993)"
        />
        <path
          d="M137.13 127.65l-.11-.01 1.45-21.08h.11l-1.45 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M390.51 398.18l-.61-.12 3.88-19.74a1.67 1.67 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.06 1.06 0 0 0-1.09.85z"
          style={{
            fill: "url(#s-abc7dd7d38-Z)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M375.6 383.56h24.01v.08H375.6z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.96 -230.489 715.52)"
        />
        <path
          d="M372.22 383.53h24.47v.08h-24.47z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.58 -240.093 721.561)"
        />
        <path
          d="M117.78 118.92l-.04-.06 20.53-12.33.04.06-20.53 12.33zM117.09 118.81l-.04-.07 20.27-12.17.04.06-20.27 12.18zM116.11 118.93l-.04-.07 20.6-12.33.04.07-20.6 12.33z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M396.09 376.1h.08v3.27h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86.86 123.755 379.075)"
        />
        <path
          d="M395.19 376.87h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.7 103.67 397.956)"
        />
        <path
          d="M137.05 108.28l-2.55-.63.02-.07 2.55.63-.02.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M393.93 377.85h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.96 67.478 432.09)"
        />
        <path
          d="M393.31 378.22h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.46 65.012 434.24)"
        />
        <path
          d="M377.35 387.05h.08v4.01h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86 103.114 391.856)"
        />
        <path
          d="M378.12 386.73h.08v3.47h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-84.68 100.17 395.115)"
        />
        <path
          d="M379.02 386.31h.08v3.21h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.67 93.023 402.29)"
        />
        <path
          d="M379.85 385.87h.08v3.11h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.3 89.809 403.803)"
        />
        <path
          d="M130.35 112.33l-3.04-.43.01-.07 3.04.42-.01.08zM131.25 111.79l-3.02-.43.01-.08 3.02.43-.01.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M380.82 385.3h.08v3.09h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.34 91.129 404.787)"
        />
        <path
          d="M381.63 384.89h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 85.093 410.808)"
        />
        <path
          d="M382.44 384.36h.08v3.04h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.6 93.251 407.54)"
        />
        <path
          d="M383.27 383.93h.08v2.91h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 86.747 409.827)"
        />
        <path
          d="M126.65 114.56l-2.87-.58.01-.07 2.88.57-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M384.89 382.9h.08v3.03h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.59 95.871 401.671)"
        />
        <path
          d="M392.15 378.5h.08v3.2h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="matrix(.17 -.98 .98 .17 -308.8 429.95)"
        />
        <path
          d="M135.15 109.42l-2.44-.71.02-.07 2.44.7-.02.08zM134.05 110.09l-2.76-.54.02-.08 2.76.55-.02.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M390.7 379.54h.08v2.77h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.21 97.762 401.957)"
        />
        <path
          d="M390.01 379.96h.08v2.8h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.13 93.905 405.439)"
        />
        <path
          d="M389.34 380.37h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-77.77 92.126 406.864)"
        />
        <path
          d="M386.96 381.72h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.64 95.25 403.031)"
        />
        <path
          d="M128.82 113.25l-2.83-.57.02-.08 2.83.57-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M385.62 382.61h.08v2.76h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-75.78 82.34 414.916)"
        />
        <path
          d="M367.83 403.28h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -242.255 739.024)"
        />
        <path
          d="M367.86 402.69h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -242.214 738.448)"
        />
        <path
          d="M368.02 402.08h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -242.062 737.824)"
        />
        <path
          d="M368.2 401.54h24.27v.11H368.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.876 737.288)"
        />
        <path
          d="M368.23 400.95h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.853 736.707)"
        />
        <path
          d="M368.39 400.34h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.702 736.083)"
        />
        <path
          d="M368.45 399.84h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.626 735.595)"
        />
        <path
          d="M368.67 399.31h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.422 735.064)"
        />
        <path
          d="M368.69 398.73h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.38 734.488)"
        />
        <path
          d="M368.85 398.12h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.23 733.864)"
        />
        <path
          d="M369.03 397.57h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.043 733.328)"
        />
        <path
          d="M369.06 396.99h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -241.02 732.747)"
        />
        <path
          d="M369.22 396.37h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.868 732.123)"
        />
        <path
          d="M369.28 395.88h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.811 731.63)"
        />
        <path
          d="M369.38 395.31h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.697 731.074)"
        />
        <path
          d="M369.41 394.73h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.67 730.474)"
        />
        <path
          d="M369.56 394.11h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.523 729.869)"
        />
        <path
          d="M369.75 393.57h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.332 729.314)"
        />
        <path
          d="M369.77 392.99h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.31 728.733)"
        />
        <path
          d="M369.93 392.37h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.144 728.133)"
        />
        <path
          d="M369.99 391.87h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -240.082 727.621)"
        />
        <path
          d="M370.17 391.2h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.92 726.961)"
        />
        <path
          d="M370.32 390.58h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.75 726.342)"
        />
        <path
          d="M370.51 390.04h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.582 725.801)"
        />
        <path
          d="M370.54 389.46h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.536 725.207)"
        />
        <path
          d="M370.69 388.84h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.39 724.601)"
        />
        <path
          d="M370.75 388.34h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.327 724.09)"
        />
        <path
          d="M370.85 387.78h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.232 723.529)"
        />
        <path
          d="M370.88 387.19h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.21 722.948)"
        />
        <path
          d="M371.04 386.58h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -239.04 722.329)"
        />
        <path
          d="M371.22 386.04h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -238.853 721.793)"
        />
        <path
          d="M371.25 385.45h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -238.83 721.212)"
        />
        <path
          d="M371.4 384.84h24.27v.11H371.4z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -238.678 720.588)"
        />
        <path
          d="M371.47 384.34h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -238.621 720.094)"
        />
        <path
          d="M361.95 399.65h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 77.922 422.03)"
        />
        <path
          d="M363.12 398.93h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 79.094 421.309)"
        />
        <path
          d="M362.53 399.31h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 78.494 421.693)"
        />
        <path
          d="M363.64 398.65h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 79.604 421.024)"
        />
        <path
          d="M364.8 397.93h20.58v.11H364.8z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 80.776 420.303)"
        />
        <path
          d="M364.21 398.31h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 80.175 420.687)"
        />
        <path
          d="M365.32 397.65h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 82.617 421.044)"
        />
        <path
          d="M366.48 396.92h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 82.453 419.304)"
        />
        <path
          d="M365.89 397.31h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 81.863 419.687)"
        />
        <path
          d="M367 396.64h20.58v.11H367z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 82.968 419.023)"
        />
        <path
          d="M368.17 395.92h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 84.134 418.298)"
        />
        <path
          d="M367.57 396.31h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 83.54 418.687)"
        />
        <path
          d="M368.68 395.7h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 84.655 418.073)"
        />
        <path
          d="M369.85 394.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 85.822 417.348)"
        />
        <path
          d="M369.26 395.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 85.227 417.737)"
        />
        <path
          d="M370.37 394.69h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 86.332 417.074)"
        />
        <path
          d="M371.54 393.97h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 87.505 416.353)"
        />
        <path
          d="M370.94 394.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 86.909 416.731)"
        />
        <path
          d="M372.05 393.7h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 88.021 416.084)"
        />
        <path
          d="M373.22 392.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 89.187 415.359)"
        />
        <path
          d="M372.63 393.37h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 88.598 415.742)"
        />
        <path
          d="M373.74 392.7h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 89.703 415.078)"
        />
        <path
          d="M374.9 391.98h20.58v.11H374.9z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 90.87 414.353)"
        />
        <path
          d="M374.31 392.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 90.28 414.736)"
        />
        <path
          d="M375.42 391.7H396v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 91.385 414.073)"
        />
        <path
          d="M376.58 390.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 92.557 413.353)"
        />
        <path
          d="M375.99 391.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 91.956 413.736)"
        />
        <path
          d="M377.1 390.69h20.58v.11H377.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 94.42 414.036)"
        />
        <path
          d="M378.27 389.97h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 94.239 412.347)"
        />
        <path
          d="M377.67 390.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 93.638 412.73)"
        />
        <path
          d="M378.78 389.75h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 94.755 412.128)"
        />
        <path
          d="M379.95 389.03h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 95.921 411.403)"
        />
        <path
          d="M379.36 389.41h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 95.327 411.792)"
        />
        <path
          d="M380.47 388.74h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 96.437 411.122)"
        />
        <path
          d="M381.04 388.41h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 97.008 410.786)"
        />
        <path
          d="M379.17 391.32a26.14 26.14 0 0 1-5.79-.58v-.11a25.67 25.67 0 0 0 6.24.58v.11zM379.12 390.74a23.72 23.72 0 0 1-5.49-.56v-.1a24.75 24.75 0 0 0 6 .55v.11zM379.22 392.49a27.73 27.73 0 0 1-6.06-.61v-.1a28.15 28.15 0 0 0 6.47.59v.11zM379.2 391.9a27.29 27.29 0 0 1-5.93-.59v-.11a27.24 27.24 0 0 0 6.36.59v.11zM379.14 393.54A28.54 28.54 0 0 1 373 393v-.1a30 30 0 0 0 6.62.58v.1zM379.23 393a28.53 28.53 0 0 1-6.16-.61v-.1a28.94 28.94 0 0 0 6.56.6v.11zM379.19 394.7a31.6 31.6 0 0 1-6.47-.61v-.1a32 32 0 0 0 6.9.6v.11zM379.15 394.12a31 31 0 0 1-6.32-.58v-.11a31.66 31.66 0 0 0 6.79.58v.11zM379.24 395.86a34.8 34.8 0 0 1-6.74-.62v-.11a34.18 34.18 0 0 0 7.13.62v.11zM379.3 395.28a33.14 33.14 0 0 1-6.68-.68v-.1a33.27 33.27 0 0 0 7 .67v.11zM379.09 397a35.11 35.11 0 0 1-6.81-.59v-.1a36.14 36.14 0 0 0 7.35.57v.12zM379.25 396.44a35.89 35.89 0 0 1-6.86-.63v-.11a35.89 35.89 0 0 0 7.24.63v.11zM379.15 398.08a38.64 38.64 0 0 1-7.09-.6v-.11a39.13 39.13 0 0 0 7.57.6v.1zM379.1 397.49a36.3 36.3 0 0 1-6.93-.59v-.1a37.28 37.28 0 0 0 7.46.58v.11zM379.33 399.24a40.37 40.37 0 0 1-7.47-.74v-.1a40.88 40.88 0 0 0 7.77.73v.11zM379.16 398.66a39.88 39.88 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM379.3 399.82a41.59 41.59 0 0 1-7.56-.71v-.1a42.35 42.35 0 0 0 7.89.7v.11zM379.22 401a44.24 44.24 0 0 1-7.72-.64v-.11a44.24 44.24 0 0 0 8.13.64v.11zM379.3 400.4a43.1 43.1 0 0 1-7.67-.71v-.11a42.57 42.57 0 0 0 8 .71v.11zM379.06 402.15a45.74 45.74 0 0 1-7.8-.6v-.1a47.73 47.73 0 0 0 8.37.59v.1zM379 401.57a43.88 43.88 0 0 1-7.62-.59v-.1a45.27 45.27 0 0 0 8.23.57v.11zM379.1 403.31a49.85 49.85 0 0 1-8.07-.61v-.11a50.37 50.37 0 0 0 8.6.61v.11zM379.08 402.73a48.22 48.22 0 0 1-7.93-.6V402a49.17 49.17 0 0 0 8.49.6v.11zM379.12 404.36a51.2 51.2 0 0 1-8.29-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM379 403.78a50.4 50.4 0 0 1-8.08-.58v-.11a51.88 51.88 0 0 0 8.7.58v.11zM379 405.52a53 53 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM379.26 404.94a52.77 52.77 0 0 1-8.53-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM379 406.69a56.87 56.87 0 0 1-8.6-.59v-.1a58.45 58.45 0 0 0 9.27.59v.1zM379 406.11a53.72 53.72 0 0 1-8.45-.59v-.1a55.75 55.75 0 0 0 9.14.57v.11zM379 407.85a60.39 60.39 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM379 407.27a57.11 57.11 0 0 1-8.73-.6v-.11a59.82 59.82 0 0 0 9.38.6v.11zM379.06 408.9a62 62 0 0 1-9.12-.62v-.1a65.45 65.45 0 0 0 9.7.61v.11zM379 408.32a61.68 61.68 0 0 1-9-.61v-.11a62.42 62.42 0 0 0 9.58.61v.11zM379 410.06a64.66 64.66 0 0 1-9.26-.58v-.11a66.36 66.36 0 0 0 9.93.58v.11zM379 409.48a63.34 63.34 0 0 1-9.13-.58v-.11a64 64 0 0 0 9.82.58v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M111.62 139.72l-.11-.02 3.93-20.77.11.02-3.93 20.77zM112.51 139.72l-.11-.02 3.75-20.84.11.02-3.75 20.84zM119.52 140.26h-.11l.16-21.24h.11l-.16 21.24z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M367.09 400.22h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 111.119 395.597)"
        />
        <path
          d="M118.02 140.11h-.11l.44-21.1h.11l-.44 21.1zM115.38 139.96l-.11-.02 2.28-21.08.1.01-2.27 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M366.04 400.15h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.08 107.157 398.66)"
        />
        <path
          d="M364.13 400.01h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 92.174 411.1)"
        />
        <path
          d="M363.35 399.97h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 86.884 415.303)"
        />
        <path
          d="M116.44 139.96l-.11-.01 1.45-21.09.11.01-1.45 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M369.67 410.52l-.61-.12 3.88-19.75a1.7 1.7 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.06 1.06 0 0 0-1.09.85z"
          style={{
            fill: "url(#s-abc7dd7d38-aa)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M380.15 412.37l-1-.41.07-22.07a1.53 1.53 0 0 1 .75-1.32l20.16-12.18a.41.41 0 0 1 .31 0l.75.23a.4.4 0 0 1 .28.39l-.93 23.24-.93-.06v-21.71a.39.39 0 0 0-.59-.33l-18.12 10.94a1.57 1.57 0 0 0-.75 1.33z"
          style={{
            fill: "url(#s-abc7dd7d38-ab)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M380.37 412.23l-.29.29.07-22.1a1.56 1.56 0 0 1 .75-1.33l20-12.07a.39.39 0 0 1 .59.34V398a3.15 3.15 0 0 1-.91 2.2V379a.39.39 0 0 0-.59-.33l-18.12 10.94a1.54 1.54 0 0 0-.75 1.33v19.53a2.47 2.47 0 0 1-.75 1.76z"
          style={{
            fill: "url(#s-abc7dd7d38-ac)",
          }}
          transform="translate(-258.81 -270.72)"
        />
      </g>
      <g id="unihockeyRight">
        <path
          d="M433.12 173.59l-50.84-3.3-4.08-32.27 45.55 2.72 9.37 32.85z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M421.15 165.53l10.95.62v-1l-6.54-19.46-9.71.22v1l8.49.47 5.46 17.05-8.65.1v1z"
          style={{
            fill: "url(#s-abc7dd7d38-ad)",
          }}
        />
        <path
          d="M421.16 164.53l10.94.62-6.54-19.46-10.16-.47.52.69 9.03.51 5.86 18.06-9.85-.56.2.61z"
          style={{
            fill: "url(#s-abc7dd7d38-ae)",
          }}
        />
        <path
          d="M683.9 417.41c-1 0-2.07 0-3.28-.13v-.1a36.15 36.15 0 0 0 7-.07v.1a34.17 34.17 0 0 1-3.72.2zM683.85 416.89c-1 0-2-.05-3.18-.13v-.1a34 34 0 0 0 6.73-.08v.1a31.81 31.81 0 0 1-3.55.21zM683.89 418.47c-1.06 0-2.17-.05-3.36-.13v-.1a39.61 39.61 0 0 0 7.26-.08v.1a36.22 36.22 0 0 1-3.9.21zM683.89 417.94c-1 0-2.12 0-3.32-.13v-.1a38.31 38.31 0 0 0 7.14-.08v.1a35.16 35.16 0 0 1-3.82.21zM684.07 419.43c-1.12 0-2.29-.05-3.62-.14v-.1a40.68 40.68 0 0 0 7.43-.05v.1c-1.32.13-2.53.19-3.81.19zM683.89 418.89c-1.08 0-2.21 0-3.4-.13v-.1a39.82 39.82 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM684.1 420.49c-1.18 0-2.41-.05-3.75-.15v-.1a44.28 44.28 0 0 0 7.75-.05v.1c-1.32.13-2.63.2-4 .2zM684.21 420c-1.18 0-2.42-.06-3.81-.16v-.1a41.88 41.88 0 0 0 7.62 0v.1c-1.26.06-2.5.16-3.81.16zM684.1 421.54q-1.86 0-3.84-.15v-.1a47.18 47.18 0 0 0 8-.05v.1c-1.26.13-2.71.2-4.16.2zM683.63 421c-1.1 0-2.2 0-3.32-.12v-.1a45 45 0 0 0 7.86-.11v.1c-1.55.14-3.04.23-4.54.23zM684.48 422.62c-1.33 0-2.71-.06-4.31-.17v-.1a49.21 49.21 0 0 0 8.24 0v.1c-1.36.11-2.62.17-3.93.17zM684.1 422.06c-1.26 0-2.57 0-3.88-.14v-.1a48.74 48.74 0 0 0 8.13-.05v.1c-1.35.13-2.76.19-4.25.19zM684.52 423.57c-1.39 0-2.85-.06-4.43-.17v-.1a52.12 52.12 0 0 0 8.48 0v.1c-1.33.11-2.66.17-4.05.17zM684.51 423.05c-1.36 0-2.77-.06-4.38-.18v-.1a51.83 51.83 0 0 0 8.36 0v.1c-1.35.13-2.64.18-3.98.18zM683.57 424.58c-1.11 0-2.31 0-3.57-.13v-.1a55.21 55.21 0 0 0 8.73-.1v.1c-1.41.12-3.16.23-5.16.23zM684.54 424.1c-1.43 0-2.91-.06-4.5-.17v-.1a56.16 56.16 0 0 0 8.61 0v.1c-1.34.07-2.65.17-4.11.17zM683.85 425.12c-1.32 0-2.61-.05-3.9-.14v-.1a57 57 0 0 0 8.85-.07v.1c-1.69.14-3.33.21-4.95.21zM684.61 426.2c-1.55 0-3.16-.05-4.75-.17v-.1a61.68 61.68 0 0 0 9.12 0v.1c-1.34.12-2.83.17-4.37.17zM683.91 425.65c-1.36 0-2.69 0-4-.14v-.1a60 60 0 0 0 9-.07v.1c-1.69.14-3.36.21-5 .21zM685.09 427.29c-1.66 0-3.38-.07-5.32-.2V427a64.32 64.32 0 0 0 9.39.06v.1c-1.37.09-2.7.13-4.07.13zM685 426.77c-1.61 0-3.27-.07-5.22-.21v-.1a63.48 63.48 0 0 0 9.22.07v.1c-1.35.09-2.64.14-4 .14zM685.16 428.35c-1.73 0-3.54-.07-5.48-.21V428a69.37 69.37 0 0 0 9.64.07v.1c-1.32.13-2.74.18-4.16.18zM685.13 427.82c-1.7 0-3.47-.07-5.41-.21v-.1a66 66 0 0 0 9.51.07v.1c-1.36.09-2.71.14-4.1.14zM685.4 429.3c-1.66 0-3.38-.07-5.32-.2v-.1a64 64 0 0 0 9.37.06v.1c-1.36.1-2.68.14-4.05.14zM685.5 428.79c-1.81 0-3.73-.07-5.86-.22v-.1a71.38 71.38 0 0 0 9.74.1v.1c-1.24.08-2.53.12-3.88.12zM685.94 430.39c-1.73 0-3.59-.08-5.81-.24v-.1a64.88 64.88 0 0 0 9.46.12v.1c-1.21.08-2.39.12-3.65.12zM684.68 429.79c-1.51 0-3-.06-4.6-.17v-.1a63.3 63.3 0 0 0 9.44 0v.1c-1.74.11-3.3.17-4.84.17zM686 431.45c-1.67 0-3.36-.08-5.66-.24v-.1a64.67 64.67 0 0 0 9.48.12v.1c-1.45.08-2.65.12-3.82.12zM685.89 430.92c-1.65 0-3.29-.08-5.59-.24v-.1a63.45 63.45 0 0 0 9.39.12v.1c-1.42.08-2.61.12-3.8.12zM685.43 432.53c-1.56 0-3.2-.06-5.27-.2v-.1a70 70 0 0 0 9.79.06v.1c-1.62.09-3.03.14-4.52.14zM686 432c-1.74 0-3.5-.08-5.79-.24v-.1a69.87 69.87 0 0 0 9.64.12v.1c-1.37.06-2.6.12-3.85.12zM685.51 433.48c-1.62 0-3.34-.06-5.43-.2v-.1a73.2 73.2 0 0 0 10 .06v.1c-1.57.09-3.02.14-4.57.14zM685.47 433c-1.59 0-3.27-.06-5.34-.21v-.1a71.56 71.56 0 0 0 9.89.07v.1c-1.6.04-3.02.14-4.55.14zM686.07 434.56c-1.92 0-3.86-.07-6.08-.23v-.1a78.87 78.87 0 0 0 10.27.12v.1c-1.44.07-2.81.11-4.19.11zM686 434c-1.87 0-3.74-.07-5.91-.23v-.09a76.83 76.83 0 0 0 10.15.1v.1c-1.54.12-2.92.12-4.24.12z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M430.62 164.77l-2.29-19.23.1-.01 2.29 19.23-.1.01z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M687.47 416.07h.1v19.56h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-5.8 -2114.301 2844.813)"
        />
        <path
          d="M422.13 164.33h-.09l.07-19.19h.1l-.08 19.19zM422.8 164.3h-.1l.09-19.08h.1l-.09 19.08zM423.53 164.44h-.1l.14-19.22h.1l-.14 19.22z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M684.93 416.02h.1v19.19h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.57 -9323.026 9734.936)"
        />
        <path
          d="M424.4 145.22h.1v19.28h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M685.64 416.05h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-2.39 -5931.935 6494.285)"
        />
        <path
          d="M686.61 416.06h.1v19.48h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.12 -3206.284 3887.979)"
        />
        <path
          d="M684.05 415.94h.1v19.3h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.81 -18596.865 18595.692)"
        />
        <path
          d="M677.47 398.81c-.7 0-1.44 0-2.26-.07v-.1a28.46 28.46 0 0 0 6.2-.22v.1a26.61 26.61 0 0 1-3.94.29zM677.48 398.29c-.68 0-1.4 0-2.24-.07v-.1a26.93 26.93 0 0 0 6-.21v.1a25.48 25.48 0 0 1-3.76.28zM677.4 399.85c-.72 0-1.46 0-2.25-.07v-.1a31.23 31.23 0 0 0 6.42-.22v.1a30.43 30.43 0 0 1-4.17.29zM677.42 399.33c-.71 0-1.45 0-2.24-.07v-.1a30.18 30.18 0 0 0 6.31-.22v.1a29.31 29.31 0 0 1-4.07.29zM677.58 400.8c-.77 0-1.59 0-2.49-.08v-.1a32.11 32.11 0 0 0 6.58-.2v.1a30 30 0 0 1-4.09.28zM677.38 400.27c-.73 0-1.47 0-2.25-.07v-.1a31.48 31.48 0 0 0 6.52-.23v.1a29.75 29.75 0 0 1-4.27.3zM677.54 401.84c-.8 0-1.63 0-2.51-.07v-.1a35.68 35.68 0 0 0 6.86-.21v.1a33 33 0 0 1-4.35.28zM677.65 401.33c-.81 0-1.66 0-2.59-.09v-.1a33.6 33.6 0 0 0 6.75-.19v.1a29.94 29.94 0 0 1-4.16.28zM677.47 402.88c-.82 0-1.65 0-2.5-.07v-.1a38.05 38.05 0 0 0 7.08-.21v.09a33.79 33.79 0 0 1-4.58.29zM677.14 402.35c-.71 0-1.41 0-2.14-.06v-.1a36.2 36.2 0 0 0 7-.27v.1a36.45 36.45 0 0 1-4.86.33zM677.86 403.94c-.92 0-1.88 0-3-.09v-.1a39.63 39.63 0 0 0 7.3-.16v.1a37.74 37.74 0 0 1-4.3.25zM677.44 403.4c-.82 0-1.66 0-2.5-.07v-.1a38.35 38.35 0 0 0 7.19-.22v.1a35 35 0 0 1-4.69.29zM677.81 404.88c-.94 0-1.91 0-3-.09v-.1a42.94 42.94 0 0 0 7.51-.16v.09a38.05 38.05 0 0 1-4.51.26zM677.85 404.36c-.93 0-1.9 0-3-.09v-.1a40.73 40.73 0 0 0 7.4-.16v.1a38.79 38.79 0 0 1-4.4.25zM677 405.9c-.71 0-1.45 0-2.23-.06v-.1a44.51 44.51 0 0 0 7.72-.28v.1a47.36 47.36 0 0 1-5.49.34zM677.8 405.4c-1 0-1.94 0-3-.08v-.1a43.15 43.15 0 0 0 7.62-.18v.1a39.38 39.38 0 0 1-4.62.26zM677.21 406.43c-.82 0-1.64 0-2.45-.07v-.1a46.17 46.17 0 0 0 7.83-.25v.1a48.36 48.36 0 0 1-5.38.32zM677.72 407.49c-1 0-2 0-3-.09v-.1a48.56 48.56 0 0 0 8.08-.18v.1a44.62 44.62 0 0 1-5.08.27zM677.22 407c-.84 0-1.67 0-2.49-.07v-.1a46.5 46.5 0 0 0 8-.25v.1a48.62 48.62 0 0 1-5.51.32zM678.21 408.55c-1.12 0-2.29 0-3.57-.11v-.1a51.59 51.59 0 0 0 8.31-.12v.1a46.78 46.78 0 0 1-4.74.23zM678.22 408c-1.09 0-2.25 0-3.55-.11v-.1a48.77 48.77 0 0 0 8.17-.12v.1a45.28 45.28 0 0 1-4.62.23zM678.2 409.59c-1.16 0-2.36 0-3.63-.1v-.1a55.56 55.56 0 0 0 8.53-.13v.1a49.18 49.18 0 0 1-4.9.23zM678.21 409.07c-1.14 0-2.33 0-3.6-.1v-.1a54.12 54.12 0 0 0 8.42-.13v.1a47.94 47.94 0 0 1-4.82.23zM678.2 410.54c-1.18 0-2.41 0-3.68-.11v-.1a57 57 0 0 0 8.74-.13v.1c-1.62.16-3.26.24-5.06.24zM678.49 410c-1.23 0-2.54 0-3.94-.12v-.1a56.42 56.42 0 0 0 8.62-.1v.1c-1.47.22-3.01.22-4.68.22zM678.66 411.6c-1.32 0-2.73 0-4.2-.13v-.1a60.51 60.51 0 0 0 8.93-.08v.1c-1.39.14-3.01.21-4.73.21zM677.52 411q-1.53 0-3-.09v-.1a57.39 57.39 0 0 0 8.84-.21v.1c-2.03.24-3.95.3-5.84.3zM678.67 412.65c-1.33 0-2.72 0-4.28-.13v-.1a63.36 63.36 0 0 0 9.19-.08v.1c-1.66.14-3.24.21-4.91.21zM678.66 412.12c-1.31 0-2.67 0-4.23-.13v-.1a60.27 60.27 0 0 0 9.06-.07v.1c-1.67.14-3.2.2-4.83.2zM678.68 413.69c-1.37 0-2.8-.05-4.35-.13v-.1a66.44 66.44 0 0 0 9.41-.08v.1c-1.66.14-3.32.21-5.06.21zM678.68 413.17c-1.36 0-2.76-.05-4.32-.13v-.1a64.88 64.88 0 0 0 9.3-.08v.1c-1.66.14-3.28.21-4.98.21zM678.68 414.63c-1.41 0-2.88 0-4.4-.13v-.1a69.46 69.46 0 0 0 9.62-.08v.1a62.7 62.7 0 0 1-5.22.21zM678.68 414.11c-1.39 0-2.84-.05-4.37-.13v-.1a67.87 67.87 0 0 0 9.51-.08v.1c-1.68.1-3.37.21-5.14.21zM679.2 415.69q-2.36 0-5-.15v-.1a71 71 0 0 0 9.85 0v.1c-1.46.09-3.05.15-4.85.15zM679.12 415.17c-1.52 0-3.14-.05-4.87-.15v-.1a71.06 71.06 0 0 0 9.74 0v.1c-1.51.08-3.13.15-4.87.15z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M682.15 397.51h.1v19.11h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-7.17 -1607.649 2337.23)"
        />
        <path
          d="M681.43 397.41h.1v19.31h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-6.26 -1923.774 2637.914)"
        />
        <path
          d="M416.66 145.72l-.02-19.11h.1l.02 19.11h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M676.15 397.42h.1v18.95h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.13 -118749.722 114351.163)"
        />
        <path
          d="M676.92 397.42h.1v18.94h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.31 -49497.147 48100.137)"
        />
        <path
          d="M420.78 145.64l-.82-18.95h.1l.82 18.94-.1.01z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M677.71 397.42h.1v18.99h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.75 -20133.33 20043.028)"
        />
        <path
          d="M679.81 397.41h.1v19.1h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-3.2 -4295.605 4904.42)"
        />
        <path
          d="M680.66 397.42h.1v19.24h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.75 -2712.63 3391.493)"
        />
        <path
          d="M678.46 397.32h.1v19.09h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.41 -10452.302 10787.127)"
        />
        <path
          d="M683.78 416.77l-2.2-18.13c-.06-.79-.94-.93-1.65-.91l-6-.19v-.57l6 .19c1.88-.05 2.18 1 2.22 1.42l2.19 18.12z"
          style={{
            fill: "url(#s-abc7dd7d38-af)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M684.48 418.1l-2.19-18.1a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M685 419.39l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.2 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M685.45 421l-2.19-18.14a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.2 18.15z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M685.9 422.14L683.71 404a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M686.36 423.48l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M686.83 424.83l-2.2-18.14a1.29 1.29 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M687.33 426.45l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M687.82 427.86l-2.19-18.13a1.32 1.32 0 0 0-1.25-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M688.29 429.3l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M688.77 430.73l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M689.28 432.47l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M689.75 433.8l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M690 435.41l-2.19-18.13a1.08 1.08 0 0 0-1-1l-6.38-.2v-.57l6.38.2a1.65 1.65 0 0 1 1.57 1.49l2.19 18.12z"
          style={{
            fill: "url(#s-abc7dd7d38-ag)",
          }}
          transform="translate(-258.81 -270.72)"
        />
        <path
          d="M678.42 396.79h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.86 -312.557 1094.575)"
        />
        <path
          d="M679.57 396.9h.1v19.37h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.47 -330.8 1113.44)"
        />
        <path
          d="M424.74 145.24l-5.71-18.56.09-.03 5.71 18.56-.09.03zM426.03 145.24l-6.09-18.62.09-.03 6.09 18.62-.09.03zM427.09 145.24l-6.3-18.52.09-.03 6.31 18.52-.1.03z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M683.87 397.04h.1v19.52h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-18.69 -267.888 1057.843)"
        />
        <path
          d="M680.17 436.44a.56.56 0 0 1-.57-.57v-20.11L674.88 401v16.46a.57.57 0 0 1-.57.57.58.58 0 0 1-.57-.57v-20.08a.58.58 0 0 1 .48-.57.57.57 0 0 1 .63.39l5.83 18.21a.5.5 0 0 1 .06.24v20.22a.57.57 0 0 1-.57.57z"
          style={{
            fill: "url(#s-abc7dd7d38-ah)",
          }}
          transform="translate(-258.81 -270.72)"
        />
      </g>
    </g>
  </Fragment>
);

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: "&&& path, &&& use, &&& g",
  size: null,
};

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    }),
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name];
    if (typeof prop !== "object") {
      return;
    }
    for (let key in prop) {
      if (
        !prop[key] ||
        typeof prop[key].width !== "number" ||
        typeof prop[key].height !== "number"
      ) {
        return new Error(
          "Invalid prop `" +
            name +
            "` supplied to `" +
            componentName +
            "`. Validation failed."
        );
      }
    }
  },
};

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: "14x15",
});
